import * as React from "react";

import { resolveColor } from "utils/commonFunctions";

interface Props {
    color?: string;
    size?: number;
}

export const ErasureIcon = (props: Props) => {
    const size = props.size ?? 16;
    const color = props.color ? `var(${props.color})` : resolveColor("--theme-primary");

    return (
        <svg width={size} height={size} viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.8756 0.477965C10.2345 -0.159322 9.19503 -0.159322 8.55389 0.477965L0.593603 8.39049C-0.047532 9.02778 -0.0475299 10.061 0.593603 10.6983L3.51406 13.6012H0.703597C0.315011 13.6012 0 13.9144 0 14.3006C0 14.6869 0.315011 15 0.703597 15H14.7755C15.1641 15 15.4791 14.6869 15.4791 14.3006C15.4791 13.9144 15.1641 13.6012 14.7755 13.6012H9.2819L15.5191 7.40143C16.1603 6.76414 16.1603 5.73089 15.5191 5.09361L10.8756 0.477965ZM7.29183 13.6012H5.50414L1.58864 9.70925C1.49705 9.61821 1.49705 9.4706 1.58864 9.37956L3.41287 7.56627L8.38806 12.5116L7.29183 13.6012ZM9.38309 11.5225L4.40791 6.5772L5.07127 5.91783L10.0464 10.8632L9.38309 11.5225Z"
                fill={color}
            />
        </svg>
    );
};
